export enum OfferStepTypes {
  FACEBOOK_BLOCKED = 'FACEBOOK_BLOCKED',
  GUIDES = 'GUIDES',
  SUPPORT = 'SUPPORT',
}

export enum CancelSubscriptionStepType {
  SELECT = 'select',
  REASON_LIST = 'reason_list',
  OFFER = 'offer',
  WHAT_LOSES = 'what_loses',
  SUCCESS = 'success',
}
